module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/048-abkhazia-05386e75d404f6c382bdaf278dca9931.svg";